// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__39kXA","PAIC":"Footer_PAIC__3JP3e"};